import ContinuePage from "@components/ContinuePage"

export default function HairstyleAlmostTherePage() {
  return <ContinuePage emoji="💇" translationKey="almostThereHairstyle" />
}
